import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AutoLoginLoaderService {

  private _showLoader: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() { }

  get showLoader(){
    console.log(this._showLoader.asObservable());

    return this._showLoader.asObservable();
  }

  set showLoader(value:any){
    console.log(value);

    this._showLoader.next(value);
  }
}
